<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

<!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Genaral Informations</vs-divider>-->


        <div class="vx-row mb-3">
          <div class="vx-col md:w-full md:mb-0">
            <ValidationProvider vid="is_ingredients" name="is_ingredients" rules="" v-slot="{ errors }">
              <small class="label">Does this product contain ingredients (or derivatives) for which GMO varieties exist
                (including any additives, preservatives, diluents,
                processing aids, solvents or enzymes)?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_ingredients" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
<!--          <div class="vx-col md:w-2/3 w-full md:mb-0">-->
<!--            <ValidationProvider v-if="form.is_ingredients" vid="is_ingredients_comment" name="is_ingredients_comment" rules="required" v-slot="{ errors }">-->
<!--              <small class="label">Comment</small>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_ingredients_comment" name="is_ingredients_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--            </ValidationProvider>-->
<!--          </div>-->
        </div>



        <vs-table :data="form.GMO_item"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

          <template slot="thead">
            <vs-th style="font-weight: normal" width="20%">Name</vs-th>
            <vs-th style="font-weight: normal" width="20%">Does it contain?</vs-th>
            <vs-th style="font-weight: normal" width="70%">Comment</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr" v-for="(tr, indextr) in data">


              <vs-td :data="data[indextr].name">
<!--                {{ data[indextr].name }}-->
                {{GMO_item_display_names[indextr]}}
              </vs-td>

              <vs-td :data="data[indextr].is_contain">
                <ValidationProvider :vid="indextr+'is_contain'" :name="indextr+'is_contain'" rules="" v-slot="{ errors }">
                  <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="data[indextr].is_contain" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>


              <vs-td :data="data[indextr].is_contain">
                <ValidationProvider v-if="data[indextr].is_contain" :vid="indextr+'is_contain_comment'" :name="indextr+'is_contain_comment'" rules="required" v-slot="{ errors }">
                  <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="data[indextr].is_contain_comment" name="is_contain_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>


        </vs-table>



<!--        <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
<!--        <div v-for="(gmo, index) in form.GMO_item" :key="index">-->
<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
<!--              <ValidationProvider :vid="index+'name'" :name="index+'name'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Name</small> <br>-->
<!--                <span class="text-bold " style="font-weight: normal">{{ gmo.name}}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/5 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_contain'" :name="index+'is_contain'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Does it contain?</small>-->
<!--                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="gmo.is_contain" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-3/5 w-full md:mb-0">-->
<!--              <ValidationProvider v-if="gmo.is_contain" :vid="index+'is_contain_comment'" :name="index+'is_contain_comment'" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Comment</small>-->
<!--                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="gmo.is_contain_comment" name="is_contain_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
<!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
<!--        </div>-->


        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_others" name="is_others" rules="" v-slot="{ errors }">
              <small class="label">Others?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_others" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>

        </div>
        <div v-if="form.is_others" v-for="(other, index) in form.is_others_name" :key="index">
          <div class="vx-row mb-3" >
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" v-model="other.name" type="text" name="name" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <small class="label">&nbsp;</small>
              <vs-button :disabled="form.is_others_name.length === 1" class="" @click="deleteOtherName(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </div>
        </div>
        <vs-button v-if="form.is_others" @click="addOtherName" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add Other Name</vs-button>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_product_ingredient_GMO" name="is_product_ingredient_GMO" rules="" v-slot="{ errors }">
              <small class="label">Does the product contain ingredients that contain GMO or consist of GMO or were produced from GMO?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_product_ingredient_GMO" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_product_ingredient_GMO" vid="is_product_ingredient_GMO_comment" name="is_product_ingredient_GMO_comment" rules="required" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_product_ingredient_GMO_comment" name="is_product_ingredient_GMO_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <ValidationProvider vid="products_GMO_free" name="products_GMO_free" rules="required" v-slot="{ errors }">
              <small class="label">Please provide details on how you ensure that
                products supplied are free from GMO material
              </small>
              <vs-textarea :disabled="__isDisabledRawMaterial(status)" v-model="form.products_GMO_free"  />
              <span class="text-danger mt-0 text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_GMO_label" name="is_GMO_label" rules="" v-slot="{ errors }">
              <small class="label">Does the product require GMO-labelling according to EC Regulations 1829/2003 and 1830/2003?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_GMO_label" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_GMO_label" vid="is_GMO_label_comment" name="is_GMO_label_comment" rules="required" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_GMO_label_comment" name="is_GMO_label_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/5 md:mb-0">
            <ValidationProvider vid="is_IP_certificate" name="is_IP_certificate" rules="" v-slot="{ errors }">
              <small class="label">Is there an IP certificate available?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_IP_certificate" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/5 w-full md:mb-0">
<!--            <ValidationProvider v-if="form.is_IP_certificate" vid="is_IP_certificate_file" name="is_IP_certificate_file" rules="" v-slot="{ errors }">-->
<!--              <small class="label">If yes, please attach a copy</small>-->
<!--              <a target="_blank" v-if="form.is_IP_certificate_file" class="float-right" :href="form.is_IP_certificate_file">view file</a>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" @change="onUploadIPCertificate($event)" type="file" name="is_IP_certificate_file" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--              <span v-if="IPCertificationFileRequired" class="text-danger text-sm">This field is required</span>-->
<!--            </ValidationProvider>-->
<!--            form.is_IP_certificate_file-->
            <small  v-if="form.is_IP_certificate" class="label">If yes, please attach a copy</small>
            <file-uploader v-on:onSetFileName="value => form.is_IP_certificate_file = value" v-on:onClickFileRemove="form.is_IP_certificate_file = null" :file="form.is_IP_certificate_file" :condition="form.is_IP_certificate" :required="false"/>

          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/5 md:mb-0">
            <ValidationProvider vid="is_GM_handled" name="is_GM_handled" rules="" v-slot="{ errors }">
              <small class="label">Are GM products handled on site?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_GM_handled" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_GM_handled" vid="is_GM_handled_details" name="is_GM_handled_details" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please provide details, including segregation and controls in place</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="test" v-model="form.is_GM_handled_details" name="is_GM_handled_details" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/5 w-full md:mb-0">
<!--            <ValidationProvider v-if="form.is_GM_handled" vid="is_GM_handled_file" name="is_GM_handled_file" :rules="form.is_GM_handled_file ? '' : 'file_required'" v-slot="{ errors }">-->
<!--              <small class="label">If yes, Provide a copy of your GM policy</small>-->
<!--              <a target="_blank" v-if="form.is_GM_handled_file" class="float-right" :href="form.is_GM_handled_file">view file</a>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" style="color:transparent; width:70px;" @change="onUploadGMHandledFile($event)" type="file" name="is_GM_handled_file" class="w-full"  :danger="errors[0]" :danger-text="errors[0]"/>-->
<!--              <span v-if="GM_handledFileRequired" class="text-danger text-sm">This field is required</span>-->
<!--            </ValidationProvider>-->
<!--            -->
            <small  v-if="form.is_GM_handled" class="label">If yes, Provide a copy of your GM policy</small>
            <file-uploader v-on:onSetFileName="value => form.is_GM_handled_file = value" v-on:onClickFileRemove="form.is_GM_handled_file = null" :file="form.is_GM_handled_file" :condition="form.is_GM_handled"/>

            <!--            form.is_GM_handled_file-->
<!--            <ValidationProvider v-if="form.is_GM_handled" vid="is_GM_handled_file" name="is_GM_handled_file" :rules="form.is_GM_handled_file ? '' : 'file_required'" v-slot="{ errors }">-->
<!--            <small class="label">If yes, Provide a copy of your GM policy</small>-->
<!--              <div class="upload-btn-wrapper">-->
<!--                <button v-bind:class="{ btn_success: form.is_GM_handled_file || !errors[0], btn_danger: !form.is_GM_handled_file  && !!errors[0]  }" class="">Upload a file</button>-->
<!--                <input @change="onUploadGMHandledFile($event)" type="file" name="myfile" />-->
<!--              </div>-->
<!--              <vs-chip @click="form.is_GM_handled_file=null" closable v-if="(form.is_GM_handled && form.is_GM_handled_file) || !!errors[0]" transparent :color="form.is_GM_handled_file || !errors[0] ? 'dark' : 'danger'"  class="mt-4">-->
<!--                <span>{{__nameSplitter(form.is_GM_handled_file)}}</span>-->
<!--              </vs-chip>-->
<!--            </ValidationProvider>-->
          </div>
        </div>


        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_GMO_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import FileUploader from '@/components/shared/FileUploader'


  export default {
        name: "SupplierManufacturingHome",
    components: {
      FileUploader
    },
      data() {
          return {
            chips:[
              'Dribbble',
              'GitHub',
              'Behance',
              'Vuejs',
              'Vuexy',
            ],
            form: {
              is_ingredients: false,
              is_others: false,
              is_product_ingredient_GMO: false,
              is_GMO_label: false,
              is_IP_certificate: false,
              is_GM_handled: false,
              is_others_name: [{name: ''}],
              GMO_item: [
                {
                  name: "corn",
                  is_contain: false,
                  is_contain_comment: ""
                },
                {
                  name: "maize",
                  is_contain: false,
                  is_contain_comment: ""
                },
                {
                  name: "potato",
                  is_contain: false,
                  is_contain_comment: ""
                },
                {
                  name: "rapeseed",
                  is_contain: false,
                  is_contain_comment: ""
                },
                {
                  name: "rice",
                  is_contain: false,
                  is_contain_comment: ""
                },
                {
                  name: "soyabean",
                  is_contain: false,
                  is_contain_comment: ""
                },
                {
                  name: "sugar_beet",
                  is_contain: false,
                  is_contain_comment: ""
                },
                {
                  name: "wheat",
                  is_contain: false,
                  is_contain_comment: ""
                }
              ]
            },
            id: null,
            status: {},
            GMO_item_display_names: [
              'Corn', 'Maize', 'Potato', 'Rapeseed', 'Rice', 'Soybean', 'Sugar beet', 'Wheat'
            ],
            IPCertificationFileRequired: false,
            GM_handledFileRequired: false
          }
      },
      mixins: [SuccessMessage, ErrorMessages],
      methods: {
        remove (item) {
          this.chips.splice(this.chips.indexOf(item), 1)
        },
        onClickNext() {
          this.$emit('notify', 1)
        },
        onClickSubmit() {
          this.status.is_raw_material_GMO_complete ? this.onClickUpdate() : this.onClickCreate()
        },

        async onClickUpdate() {
          if (this.form.is_IP_certificate && !this.form.is_IP_certificate_file || this.form.is_GM_handled && !this.form.is_GM_handled_file ) {
            if (this.form.is_IP_certificate && !this.form.is_IP_certificate_file) {
              this.IPCertificationFileRequired = true
            }
            if(this.form.is_GM_handled && !this.form.is_GM_handled_file) {
              this.GM_handledFileRequired = true
            }
          } else {
            this.$vs.loading()
            try {
              if (this.form.is_others) {
                this.form.is_others_name = this.form.is_others_name.map((m) => {
                  return m.name
                })
              } else {
                this.form.is_others_name = []
              }
              const data= (await SupplierRawMaterialRepository.UpdateRawMaterialGeneticallyModifiedOrganisms(this.id, this.form))
              this.showSuccessMessage('Raw Material Genetically Modified Organisms Details Updated!')
              this.onClickNext()
            }catch (e) {
              this.convertAndNotifyError(e)
            }
            this.$vs.loading.close()
          }
        },
        async onClickCreate() {
          if (this.form.is_IP_certificate && !this.form.is_IP_certificate_file || this.form.is_GM_handled && !this.form.is_GM_handled_file ) {
            if (this.form.is_IP_certificate && !this.form.is_IP_certificate_file) {
              this.IPCertificationFileRequired = true
            }
            if(this.form.is_GM_handled && !this.form.is_GM_handled_file) {
              this.GM_handledFileRequired = true
            }
          } else {
            this.$vs.loading()
            try {
              if (this.form.is_others) {
                this.form.is_others_name = this.form.is_others_name.map((m) => {
                  return m.name
                })
              } else {
                this.form.is_others_name = []
              }
              const data= (await SupplierRawMaterialRepository.CreateRawMaterialGeneticallyModifiedOrganisms(this.form))
              this.showSuccessMessage('Raw Material Genetically Modified Organisms Details Created!')
              this.onClickNext()
            }catch (e) {
              this.convertAndNotifyError(e)
            }
            this.$vs.loading.close()
          }
        },
        async onUploadIPCertificate(event, model_name) {
          this.$vs.loading();
          try {
            const file = await event.target.files[0]
            let formData = new FormData();
            formData.append('file', file);
            this.form.is_IP_certificate_file = (await SupplierRepository.uploadFile(formData)).data.data.file
            this.IPCertificationFileRequired = false
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
        async onUploadGMHandledFile(event, model_name) {
          this.$vs.loading();
          try {
            const file = await event.target.files[0]
            let formData = new FormData();
            formData.append('file', file);
            this.form.is_GM_handled_file = (await SupplierRepository.uploadFile(formData)).data.data.file
            this.GM_handledFileRequired = false
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
        async loadData() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialGeneticallyModifiedOrganisms(this.id)).data
          this.form =data
          if (this.form.is_others_name.length !== 0) {
            this.form.is_others_name = this.form.is_others_name.map((m) => {
              return {name: m}
            })
          } else {
            this.addOtherName()
          }
          this.$vs.loading.close()
        },
        async loadStatus() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
          this.status =data
          this.$vs.loading.close()
        },
        addOtherName() {
          this.form.is_others_name.push(
            {name: ''}
          )
        },
        deleteOtherName(index) {
          this.form.is_others_name.splice(index, 1)
        }

      },
      async mounted() {
        this.id = this.$route.params.id
        this.form.supplier_raw_material_id =  this.id
        await this.loadStatus()
        if (this.status.is_raw_material_GMO_complete) {
          await this.loadData()
        }
      }
    }
</script>

<style scoped>

</style>
